require('./hireNewCreditCardSuccess.scss');

import React from 'react';
import { i18n } from 'core/i18n';
import PersonalDataHelper from 'utilities/personalDataHelper';
import { formatAmountObject } from 'utilities/currencyHelper';
import { getLastNChars } from 'utilities/stringHelper';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OKMessage } from 'commonsComponents/OKMessage';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';

import { PENDING } from 'constants/hireCardSubmitScenarios';

import {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    PERCENTAGE_SYMBOL,
    VIA_T
} from 'constants/index';
import { catalogue, analyticsId } from '../analytics/hireNewCreditCardViewAnalytics';
const { FormattedText, formatText, getLanguage } = i18n;
export const HireNewCreditCardSuccess = ({
    getContextTranslate,
    immAccount,
    immHireCardNameSelector,
    immHireCreditLimit,
    immHirePaymentMethod,
    hireCreditCard,
    immShippingAddress,
    immHireCardImageSelector,
    immProfile,
    processDetail,
    cardType
}) => {
    const buildSummary = () => {

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${getContextTranslate('summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${getContextTranslate('summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${getContextTranslate('summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = formatText(paymentMethod[paymentMethodType]);
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : PERCENTAGE_SYMBOL;
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${immHirePaymentMethod.get('value')} ${paymentMethodSymbol}`;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-neruda-success__summary">
                <div className="col-xs-6 hire-card-neruda-success__summary-left-column">
                    {cardType === VIA_T ? null : (
                        <>
                            <FormattedText
                                className="col-xs-12 hire-card-neruda-success__summary-title"
                                value={getContextTranslate('summarySelectedName')}
                            />
                            <div className="col-xs-12 hire-card-neruda-success__summary-value">
                                {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                            </div>
                        </>
                    )}
                    <FormattedText
                        className="col-xs-12 hire-card-neruda-success__summary-title"
                        value={getContextTranslate('summarySelectedLimit')}
                    />
                    <OneLineSymbolAmount
                        amountObject={limitObj}
                        amountObjectFormatted={formatAmountObject(limitObj, true)}
                        className="col-xs-12 hire-card-neruda-success__summary-value"
                        language={getLanguage()}
                        trimDecimals={true}
                    />
                </div>
                <div className="col-xs-5 col-xs-offset-1">
                    <FormattedText
                        className="col-xs-12 hire-card-neruda-success__summary-title"
                        value="cardDetails-associatedAccount"
                    />
                    <div className="col-xs-12 hire-card-neruda-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-neruda-success__summary-title"
                        value={getContextTranslate('summaryPaymentMethod')}
                    />
                    <div className="col-xs-12 hire-card-neruda-success__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
            </div>
        );
    }

    const buildTexts = () => {

        let textElement;
        let titleKey;

        const pendingAnalysis = hireCreditCard.get('hiringStatus') === PENDING;

        if (pendingAnalysis) {
            titleKey = getContextTranslate('successTitlePending');
            textElement = (
                <div className="col-xs-8 hire-card-neruda-success__text">
                    <FormattedText value={getContextTranslate('successText1Pending')} />
                </div>
            );
        } else {
            const address = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);

            titleKey = getContextTranslate('successTitleCompleted');
            textElement = (
                <div className="col-xs-8 hire-card-neruda-success__text">
                    <FormattedText value={getContextTranslate('successText1Completed')} />
                    {cardType !== 'virtual' &&
                        <div className="hire-card-neruda-success__address">
                            <i className="hire-card-neruda-success__address-icon icon icon-s-locacion" />
                            {address}
                        </div>
                    }
                    <FormattedText value={getContextTranslate('successText2Completed')} />
                </div>
            );
        }

        return {
            textElement,
            titleKey
        };
    }


    const { textElement, titleKey } = buildTexts();
    const summarySection = buildSummary();
    const wizardSuccessIcon = hireCreditCard.get('hiringStatus') === PENDING ? 'pending' : '';
    const goBackButton = {
        label: (
            <FormattedText value={getContextTranslate("successBackButtonText")} />
        ),
        url: '/myprofile/cards'
    };
    const selectedImageId = immHireCardImageSelector.get('selectedImageId');
    const imgSrc = immHireCardImageSelector.getIn(['imagesById', selectedImageId, 'url']);
    return (
        <>
            {immProfile.get('isFetching') ?
                <LoadingSection />
                :
                <WizardSuccess
                    iconModifier={wizardSuccessIcon}
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText(titleKey)}
                    tealium={catalogue[analyticsId.NERURA_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-neruda-success">
                        <div className="row">
                            <div className="hire-card-neruda-success__card ">
                                <div className="hire-card-sidebar__image-container">
                                    <img className="hire-card-sidebar__image" src={imgSrc} />
                                </div>
                                {textElement}
                            </div>
                        </div>
                        {summarySection}
                        <div className="row hire-card-neruda-success__message">
                            <OKMessage type="informative">
                                <FormattedText value='hireNewCreditCard-succes_block_subtitle' />
                            </OKMessage>
                        </div>
                    </article>
                </WizardSuccess>
            }
        </>
    );
};
